export default "__VITE_ASSET__CMAtxI_6__"